<template>
    <modal class="account-modal" @close="actionHideModal">
        <template slot="header">
            <div class="modal-title-container">
                <h4 class="modal-title">{{$t('Merge accounts')}}</h4>
                <div class="icon-container">
                    <md-icon @click.native="actionHideModal">{{$t('clear')}}</md-icon>
                </div>
            </div>
            <p>{{$t('Select email to which you want to merge other accounts.')}}</p>
        </template>
        <template slot="body">
            <md-table class="table-striped">
                <md-table-row v-for="(user, key) in users" :key="key">
                    <md-table-cell class="modal-radio">
                        <md-radio v-model="selectedUserId" :value="user.id"></md-radio>
                    </md-table-cell>
                    <md-table-cell class="modal-username" v-text="user.email"></md-table-cell>
                </md-table-row>
            </md-table>
        </template>
        <template slot="footer">
            <md-button class="md-simple modal-btn" @click.native="actionHideModal">{{$t('Cancel')}}</md-button>
            <md-button class="md-primary md-button modal-btn" @click.native="actionMerge">{{$t('Merge accounts')}}</md-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../components/Modal";
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "UserMergeModal",
        components: {Modal},
        computed: {
            ...mapGetters('indexTable', {
                users: 'getSelectedItems',
            })
        },
        data() {
            return {
                selectedUserId: null,
            }
        },
        methods: {
            actionHideModal() {
                this.$parent.showMergeModal = false;
            },
            actionMerge() {
                this.$api.mergeAccounts({
                    data: {
                        main: this.selectedUserId,
                        accounts: this.users.map(user => {
                            return user.id;
                        }),
                    }
                }).then(() => {
                    let el = document.getElementById('user-index-table');
                    let vueInstance = el.__vue__;
                    vueInstance.$parent.refreshData();
                    this.clearSelectedItems();
                }).finally(() => {
                    this.actionHideModal();
                });
            },
            ...mapMutations('indexTable', {
                clearSelectedItems: 'clearSelectedItems',
            })
        },
        mounted() {
            this.selectedUserId = this.users[0].id;
        }
    }
</script>